import BookIcon from '@stripcash/ui-kit/icons/book.svg';
import UserIcon from '@stripcash/ui-kit/icons/user.svg';
import UserAddIcon from '@stripcash/ui-kit/icons/userAdd.svg';
import GraphIcon from '@stripcash/ui-kit/icons/graph.svg';
import CoinIcon from '@stripcash/ui-kit/icons/coin.svg';
import LayoutIcon from '@stripcash/ui-kit/icons/layout.svg';
import TargetIcon from '@stripcash/ui-kit/icons/target.svg';
import LinkIcon from '@stripcash/ui-kit/icons/link.svg';
import GearWheelIcon from '@stripcash/ui-kit/icons/gearWheel.svg';

export const icons = {
  book: BookIcon,
  user: UserIcon,
  userAdd: UserAddIcon,
  graph: GraphIcon,
  coin: CoinIcon,
  layout: LayoutIcon,
  target: TargetIcon,
  link: LinkIcon,
  gearwheel: GearWheelIcon,
};

export const TOOLTIP_STRING_LIMITS = {
  parentGroup: 22,
  rootGroup: 20,
};
